import { white } from '../colors';
export var MuiSnackbarContent = {
    styleOverrides: {
        action: {
            '& [class*=MuiButton-root]': {
                color: white,
            },
        },
    },
};
